
import { Job } from "../job.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";
import { UserSerializer } from "./userSerializer.ts";

export class JobSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new Job();
        this._copyLayersAttributes(gp, data);

        if (data.user) {
            const userSerializer = new UserSerializer();
            gp.user = userSerializer.deserialize(data.user);
        }

        return gp;
    }

}
